<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="dateDisplay"
              :label="label"
              :placeholder="datePlaceholder"
              outlined
              dense
              hide-details
              readonly
              append-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="selectedDate"
            @input="onDateSelected"
          />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { parseDateOnly, formatDateForPicker, formatDateForDisplay } from '@/utils/dateHelper';

export default {
  name: 'LocalBookDatePicker',
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    label: {
      type: String,
      default: 'Published Date'
    },
    datePlaceholder: {
      type: String,
      default: 'MM / DD / YYYY'
    }
  },
  emits: ['input'],
  data() {
    return {
      selectedDate: null,
      dateMenu: false
    };
  },
  computed: {
    dateDisplay() {
      return formatDateForDisplay(this.selectedDate);
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.parseAndSetDate(newVal);
      },
      immediate: true
    }
  },
  methods: {
    parseAndSetDate(dateString) {
      if (dateString && dateString !== '#') {
        const date = parseDateOnly(dateString);
        if (date) {
          this.selectedDate = formatDateForPicker(date);
        }
      } else {
        this.selectedDate = null;
      }
    },
    
    onDateSelected() {
      this.dateMenu = false;
      
      if (this.selectedDate) {
        this.$emit('input', this.selectedDate);
      }
    }
  }
};
</script>